import React from 'react';
import { Stack, IStackProps, Copy } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';
import { getResultsSummaryText } from 'src/components/DataTable/components/DataTableSummary/dataTableSummary.utils';

export type DataTableSummaryProps = {
  entityName?: string;
} & Pick<IStackProps, 'x' | 'y'>;

export const DataTableSummary: React.FC<DataTableSummaryProps> = ({
  entityName,
  x = 'none',
  y = 'none',
}): React.ReactElement | null => {
  const { tableState, total, isError, isEmpty } = useDataTableContext();
  const { page, pageSize } = tableState;

  if (isError || isEmpty) {
    return null;
  }

  const summaryText = getResultsSummaryText({
    page,
    pageSize,
    total,
    entityName,
  });

  return (
    <Stack x={x} y={y} width="100%" height="100%">
      <Copy variant="body" color="secondaryText">
        {summaryText}
      </Copy>
    </Stack>
  );
};
